const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;

if (pageType !== "cart") {
  let counter = 0;
  const interval = setInterval(() => {
    const footerPrice = document.querySelector(".cart__total-price-info");

    if (footerPrice) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
} else {
  let counter = 0;
  const interval = setInterval(() => {
    const vatInputWrapper = document.querySelector(
      ".bss-b2b-vat-input-wrapper"
    );

    if (vatInputWrapper) {
      handleTEBox();
      clearInterval(interval);
    } else {
      counter += 100;
      if (counter >= 10000) {
        clearInterval(interval);
      }
    }
  }, 100);
}

function handleTEBox() {
  const translations = BSS_B2B.te.teTranslations;
  const headerText = document.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (headerText) {
    headerText.innerText = translations.form_header_text;
  }

  const subtitleText = document.querySelector(
    ".bss-b2b-translation-vat-form_subtitle_text"
  );
  if (subtitleText) {
    subtitleText.innerText = translations.form_subtitle_text;
  }

  const successMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_success_message"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_success_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_success_message_us_ein"
    ),
  ];

  successMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_success_message || "";
          break;
        case 1:
          msg.innerText = translations.form_success_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_success_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_success_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_success_message_us_ein || "";
          break;
      }
    }
  });

  const errorMessages = [
    document.querySelector(".bss-b2b-translation-vat-form_error_message"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_uk"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_abn"),
    document.querySelector(".bss-b2b-translation-vat-form_error_message_gst"),
    document.querySelector(
      ".bss-b2b-translation-vat-form_error_message_us_ein"
    ),
    document.querySelector(
      ".bss-b2b-translation-vat-form_validate_country_code_message"
    ),
  ];

  errorMessages.forEach((msg, index) => {
    if (msg) {
      switch (index) {
        case 0:
          msg.innerText = translations.form_error_message || "";
          break;
        case 1:
          msg.innerText = translations.form_error_message_uk || "";
          break;
        case 2:
          msg.innerText = translations.form_error_message_abn || "";
          break;
        case 3:
          msg.innerText = translations.form_error_message_gst || "";
          break;
        case 4:
          msg.innerText = translations.form_error_message_us_ein || "";
          break;
        case 5:
          msg.innerText = translations.form_validate_country_code_message || "";
          break;
      }
    }
  });
}

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let item of MutationList) {
        if (item.target.classList.contains("cart-count") && window.location.pathname.includes("/cart")) {
          checkVATHeaderAndReload();
          BSS_B2B.observer.cartSubject.listenCartCheckout()
        }
        if (item.target.classList.contains("cart-count") && !window.location.pathname.includes("/cart")) {
          BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
        }     
        if (item.target.id === 'infiniteScrollContainer') {
          setTimeout(showOptionATC, 1500);
        }         
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}

function checkVATHeaderAndReload() {
  const wrapper = document.querySelector(
    ".bss-b2b-tax-ex-wrapper.bss-config-header"
  );
  if (!wrapper) return;

  const header = wrapper.querySelector(
    ".bss-b2b-translation-vat-form_header_text"
  );
  if (!header) return;

  const content = header.textContent?.trim();

  if (!content) {
    console.log("Reload triggered: Empty or missing content");
    location.reload();
  }
}


function showOptionATC(){
  let interval = setInterval(()=>{
    document.querySelectorAll(".bss-b2b-quick-order-list #AddToCart [bss-b2b-product-price]:has(span+span) span:first-child").forEach(span => {
      span.remove()
    })
  },10)
  setTimeout(()=>{
    clearInterval(interval);
  },1000)
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(showOptionATC, 2000);
});

let listProductIdsLength = [];
const resetStorage = async () => {
  const listFormIds = [];
  BSS_B2B.storage.productStorage.setAll(new Map());
  BSS_B2B.storage.variantStorage.setAll(new Map());
  document.querySelectorAll("[bss-b2b-product-active]").forEach((ele) => {
    ele.removeAttribute("bss-b2b-product-active");
  })
  const resL = await BSS_B2B.storage.productStorage.load();
  if (listProductIdsLength >= resL?.productIds?.length) return;
  listProductIdsLength = resL?.productIds?.length;
  resL.notExistProductIds = resL.productIds;
  if (resL.notExistProductIds?.length || resL.productIds?.length || resL.variantIds?.size) {
      BSS_B2B.observer.productSubject.notifyObserver("LazyProduct","LoadedLazyProduct", {
          ...resL,
      });
  }
  window.dispatchEvent(new Event("bss_b2b:CustomInitProductSubject"));
  document.querySelectorAll("[bss-b2b-product-form-id]").forEach(async (ele) => {
    const formId = ele.getAttribute("bss-b2b-product-form-id");
    ele.addEventListener("click", () => {
      if(listFormIds.includes(formId)) return;
      listFormIds.push(formId);
       BSS_B2B.observer.productSubject.notifyObserver("QuickOrderListUpdated", "QuickOrderListUpdated", {formId})
    })
  })
}
function debounceC(callback, delay) {
    let timeoutID= null;
    return function (...args) {
        const context = this;
        if (timeoutID) clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
            callback.apply(context, args);
        }, delay)
    };
}
const handleDebounceX = debounceC(resetStorage, 1000);
window.addEventListener('scroll', () => {
    handleDebounceX();
});